import { create } from 'zustand';
import axios from 'axios';

// In browser/nginx mode REACT_APP_SERVER_URL is unset → relative URLs work as before.
// In desktop app (Electron/Tauri) set REACT_APP_SERVER_URL=https://your-vps in .env
// so all API calls route directly to the VPS instead of window.location.
const _SERVER = process.env.REACT_APP_SERVER_URL || '';
const api = axios.create({ baseURL: _SERVER });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

/** Decode JWT payload without verifying signature (client-side only). */
function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return {};
  }
}

function claimsFromStorage() {
  const t = localStorage.getItem('token');
  return t ? parseJwt(t) : {};
}

export const useAuth = create((set) => ({
  token: localStorage.getItem('token'),
  claims: claimsFromStorage(),   // { sub, super, agent_token, ... }
  tokenExpiresAt: localStorage.getItem('token_expires_at') || null,
  user: null,

  login: async (username, password) => {
    const form = new URLSearchParams({ username, password });
    const { data } = await api.post('/auth/login', form);
    localStorage.setItem('token', data.access_token);
    localStorage.removeItem('token_expires_at');
    set({ token: data.access_token, claims: parseJwt(data.access_token), tokenExpiresAt: null });
    return data;
  },

  authHeaders: () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  },

  // Used by token-login flow — store JWT received from /api/access/token-login
  setToken: (t, expiresAt) => {
    localStorage.setItem('token', t);
    if (expiresAt) localStorage.setItem('token_expires_at', expiresAt);
    else localStorage.removeItem('token_expires_at');
    set({ token: t, claims: parseJwt(t), tokenExpiresAt: expiresAt || null });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('token_expires_at');
    set({ token: null, claims: {}, user: null, tokenExpiresAt: null });
  },
}));

export { api };
